import {
  getUser
} from "@/api/login";
import store from '../store/index';
const tools = {}
//手机正则
tools.checkPhone = (phone) => {
  var patrn = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/
  if (!patrn.test(phone) || phone === '') {
    return false;
  } else {
    return true;
  }
}

//验证身份证号
tools.checkIdCard = (value) => {
  const numberReg = /^\d{15}|\d{}18$/;
  return numberReg.test(value);
}
tools.refUserinfo = () => {
  getUser().then(res => {
    store.dispatch("getUserInfo", res.data);
    localStorage.setItem('USER', JSON.stringify(res.data))
  });
}
//处理减法精度丢失
tools.mathSubtract = (arg1, arg2) => {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (error) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (error) {
    r2 = 0;
  }
  let s = 10
  if (r2 == 2) {
    s = 100
  }
  if (r2 == 3) {
    s = 1000
  }
  m = Math.pow(s, Math.max(r1, r2));
  return ((arg1 * m - arg2 * m) / m);
}
//处理乘法精度丢失
tools.mathMultiply = (arg1, arg2) => {
  let m = 0;
  let s1 = arg1.toString();
  let s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length; // 小数相乘，小数点后个数相加
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  );
}
//处理除法精度丢失
tools.mathDivide = (arg1, arg2) => {
  let m1 = 0;
  let m2 = 0;
  let n1 = 0;
  let n2 = 0;
  try {
    m1 = arg1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    m2 = arg2.toString().split('.')[1].length;
  } catch (e) {}
  n1 = Number(arg1.toString().replace('.', ''));
  n2 = Number(arg2.toString().replace('.', ''));
  /**
   * 将除法转换成乘法
   * 乘以它们的小数点后个数差
   */
  return tools.mathMultiply(n1 / n2, Math.pow(10, m2 - m1));
}

//验证是否纯数字或纯英文
tools.checkNum_eng = (type, value) => {
  let num = /^[0-9]+$/;
  let eng = /^[A-Za-z]+('[a-zA-Z-]+|[a-zA-Z-]*)$/;
  if (type == 'num') {
    return num.test(value)
  }
  if (type == 'eng') {
    return eng.test(value)
  }

}
tools.timeFormatter = (time, format) => {
  if (arguments.length === 0 || !time) {
    return null
  }
  format = format || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      } else {
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
    z: date.getMilliseconds(),
  }
  const timeStr = format.replace(/{([ymdhisaz])+}/g, (result, key) => {
    const value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

//复制
tools.copyText = (value, that, msg = '') => {
  const aux = document.createElement('textarea')
  // aux.setAttribute('value', value)
  aux.value = value
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  that.$message.success('复制成功' + msg)
}
tools.checkNum = (v) => {
  let num = /^[1-9]+[0-9]*$/
  if (num.test(v)) {
    return true
  } else {
    return false
  }
}
//防抖
tools.debounce = (fn, delay) => {
  let time = null; //time用来控制事件的触发
  return function() {
    let args = arguments;
    if (time !== null) {
      clearTimeout(time);
    }
    time = setTimeout(() => {
      fn.apply(this, args);

    }, delay)
  }
}
// 节流
export function throttle(fn, delay) {
  let flag = true
  return function() {
    let th = this;
    let args = arguments;
    if (!flag) {
      //未超过时间间隔，flag无效，不执行fn
      return false
    }
    fn.apply(th, args)
    flag = false //在时间间隔内把状态位flag设为无效（false）
    setTimeout(() => {
      flag = true //超过时间间隔把状态位flag设为有效（true）
    }, delay)
  }
}
tools.parseTime = (time, cFormat) => {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
export default tools



// WEBPACK FOOTER //
// ./src/utils/public.js